export enum JobsStage {
	MAIN = 'main',
	ABOUT = 'about',
	SELECT_VEHICLE = 'select_vehicle',
}
